module.exports = __webpack_public_path__ + "static/media/bat8.781fa84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat8.png
// module id = 476
// module chunks = 0